import { render, staticRenderFns } from "./ReportDesktopMoreDishes.vue?vue&type=template&id=91c2afe4"
import script from "./ReportDesktopMoreDishes.vue?vue&type=script&lang=js"
export * from "./ReportDesktopMoreDishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports